import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

// Customer auth via WhatsApp OTP (demo mode). Token stored for API calls.
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const saved = localStorage.getItem("gt_customer");
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  });
  const [loginOpen, setLoginOpen] = useState(false);
  const [pendingRedirect, setPendingRedirect] = useState(null);

  useEffect(() => {
    if (user) {
      localStorage.setItem("gt_customer", JSON.stringify(user));
      if (user.token) localStorage.setItem("gt_customer_token", user.token);
    } else {
      localStorage.removeItem("gt_customer");
      localStorage.removeItem("gt_customer_token");
    }
  }, [user]);

  const login = useCallback((data) => setUser(data), []);
  const logout = useCallback(() => setUser(null), []);
  const openLogin = useCallback((redirect = null) => {
    setPendingRedirect(redirect);
    setLoginOpen(true);
  }, []);
  const closeLogin = useCallback(() => setLoginOpen(false), []);

  const value = useMemo(
    () => ({ user, login, logout, loginOpen, openLogin, closeLogin, pendingRedirect }),
    [user, login, logout, loginOpen, openLogin, closeLogin, pendingRedirect]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
